;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { AnalyticsApp } from '../posthog/types';

function getSentryDsn(): string | undefined {
  return process.env.SENTRY_DSN ?? process.env.NEXT_PUBLIC_SENTRY_DSN;
}

/** Sentry runs only when `ENVIRONMENT_NAME` is `prod` (see app `next.config` `env`). */
export function isSentryEnabled(): boolean {
  return process.env.ENVIRONMENT_NAME === 'prod';
}

export function getSentryInitOptions(app: AnalyticsApp) {
  if (!isSentryEnabled()) return null;

  const dsn = getSentryDsn();
  if (!dsn) return null;

  return {
    dsn,
    environment: 'production',
    enabled: true,
    tracesSampleRate: 0.1,
    initialScope: {
      tags: {
        app,
      },
    },
  };
}
